import type { PaginatedListJSON, Attribute, SearchParams } from 'stores/PaginationTypes';
import type { ReportHistory } from 'report/types';
import PaginationURL from 'util/PaginationURL';
import { SOURCE_URL } from 'report/Constants';
import FiltersForQueryParams from 'components/common/EntityFilters/FiltersForQueryParams';
import fetch from 'logic/rest/FetchProvider';
import { qualifyUrl } from 'util/URLUtils';

type PaginatedReportHistoryResponse = PaginatedListJSON & {
  elements: Array<ReportHistory>;
  attributes: Array<Attribute>;
};

const fetchReportHistory = (reportId: string, searchParams: SearchParams) => {
  const url = PaginationURL(
    `${SOURCE_URL}/reports/${reportId}/history`,
    searchParams.page,
    searchParams.pageSize,
    searchParams.query,
    {
      sort: searchParams.sort.attributeId,
      order: searchParams.sort.direction,
      filters: FiltersForQueryParams(searchParams.filters),
    },
  );

  return fetch<PaginatedReportHistoryResponse>('GET', qualifyUrl(url)).then(
    ({ elements, total, count, page, per_page: perPage, attributes }) => ({
      list: elements,
      pagination: { total, count, page, perPage },
      attributes,
    }),
  );
};

export default fetchReportHistory;
